import { useQuery } from '@tanstack/react-query';
import { FreelancerService } from '../../services/freelancer';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { ICustomerFullProfile } from '../../interfaces/customer';
import { parseAxiosError } from '../../services/axios';
import { useNotification } from '../../+state/useNotification';

interface IProps extends IBaseUseQueryProps<ICustomerFullProfile> {
  customerId: number;
}

export const GET_CUSTOMER_INFO_QUERY_KEY = 'get-customer-info';

export const useGetCustomerInfo = ({ customerId, onError, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_CUSTOMER_INFO_QUERY_KEY, customerId],
    queryFn: () => FreelancerService.getOneById(customerId),
    refetchOnWindowFocus: false,
    retry: 0,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      onError?.(err);
    },
    ...props
  });
};